(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(scope = document) {
    scope.querySelectorAll('[data-hero]').forEach(hero => {
      const height = Math.max(240, window.innerHeight - hero.getBoundingClientRect().top - window.scrollY);
      hero.style.height = `${height}px`;
    });
    scope.querySelectorAll('video').forEach(video => { if (reduceMotion.matches) video.pause(); });
    scope.querySelectorAll('.styling-edit').forEach(edit => {
      const slides = [...edit.querySelectorAll('[data-slide]')];
      const copy = [...edit.querySelectorAll('[data-slide-copy]')];
      let index = 0;
      const show = (next) => {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== index;
          copy[i].hidden = i !== index;
          const video = slide.querySelector('video');
          if (!video) return;
          if (i === index && !reduceMotion.matches) video.play().catch(() => {}); else video.pause();
        });
        edit.querySelector('[data-slide-count]').textContent = `${index + 1} / ${slides.length}`;
      };
      if (!edit.dataset.initialized) {
        edit.querySelectorAll('[data-slide-step]').forEach(button => button.addEventListener('click', () => show(index + Number(button.dataset.slideStep))));
        edit.dataset.initialized = 'true';
      }
      show(0);
    });
    scope.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const product = select.closest('[data-product]');
        const available = option.dataset.available === 'true';
        const button = product.querySelector('[data-add-button]');
        button.disabled = !available;
        button.textContent = available ? 'Add to bag' : 'Sold out';
        const quantity = product.querySelector('[data-quantity]');
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        const price = product.querySelector('[data-price]');
        price.textContent = option.dataset.price;
        if (option.dataset.compare) { const del = document.createElement('s'); del.textContent = option.dataset.compare; price.append(' ', del); }
        const url = new URL(window.location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
        const media = [...product.querySelectorAll('[data-media-id]')].find(el => el.dataset.mediaId === option.dataset.media);
        if (media) media.scrollIntoView({behavior: reduceMotion.matches ? 'instant' : 'smooth', block: 'nearest', inline: 'start'});
        product.querySelector('[data-product-message]').textContent = '';
      });
    });
    scope.querySelectorAll('[data-product-form]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      form.addEventListener('submit', async (event) => {
        if (!window.fetch) return;
        event.preventDefault();
        const button = form.querySelector('[data-add-button]');
        const message = form.querySelector('[data-product-message]');
        const oldLabel = button.textContent;
        button.disabled = true; button.textContent = 'Adding…'; message.textContent = '';
        try {
          const url = new URL(form.action); url.pathname = url.pathname.replace(/\/$/, '') + '.js';
          const cartBody = new FormData(form);
          if (window.HanifaCart) { cartBody.set('sections', 'cart-drawer'); cartBody.set('sections_url', window.location.pathname); }
          const response = await fetch(url, {method: 'POST', body: cartBody, headers: {'Accept':'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Could not add this item. Please try again.');
          message.textContent = 'Added to your bag.';
          if (window.HanifaCart) {
            try { await window.HanifaCart.refresh(result.sections?.['cart-drawer']); window.HanifaCart.open(button); }
            catch (_) { message.textContent = 'Added to your bag. Open Bag to view it.'; }
          }
          document.getElementById('CartStatus').textContent = message.textContent;
          const cartUrl = new URL(form.action); cartUrl.pathname = cartUrl.pathname.replace(/\/add\/?$/, '.js');
          try {
            const cartResponse = await fetch(cartUrl, {headers:{'Accept':'application/json'}});
            if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count); }
          } catch (_) { /* The product was added; a count refresh must not undo success. */ }
        } catch (error) { message.textContent = error.message || 'Connection failed. Please try again.'; }
        finally {button.disabled = false; button.textContent = oldLabel;}
      });
    });
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-menu-open]');
    const dialog = document.getElementById('SiteMenu');
    if (opener && dialog) {if(window.HanifaSidebar)window.HanifaSidebar.open(dialog);else dialog.showModal(); document.documentElement.classList.add('hf-dialog-open'); document.querySelectorAll('[data-menu-open]').forEach(el => el.setAttribute('aria-expanded','true'));}
    if (dialog && event.target.closest('[data-menu-close]')) {if(window.HanifaSidebar)window.HanifaSidebar.close(dialog);else dialog.close();}
    if (dialog && event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {if(window.HanifaSidebar)window.HanifaSidebar.close(dialog);else dialog.close();} }
    const toggle = event.target.closest('[data-video-toggle]');
    if (toggle) {const video=toggle.closest('[data-hero]').querySelector('video');if (!video) return;if(video.paused){video.play().then(()=>{toggle.textContent='Pause';toggle.setAttribute('aria-label','Pause video');}).catch(()=>{});}else{video.pause();toggle.textContent='Play';toggle.setAttribute('aria-label','Play video');}}
  });
  document.addEventListener('close', event => {if(event.target.id==='SiteMenu')document.querySelectorAll('[data-menu-open]').forEach(el=>el.setAttribute('aria-expanded','false'));},true);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  initialize();
  const band = document.querySelector('.wordmark-band');
  if (band) new IntersectionObserver(entries => document.body.classList.toggle('hero-passed',!entries[0].isIntersecting)).observe(band);
})();
